import { useState } from 'react';
import { useIdeas, type SortMode } from '@/hooks/useIdeas';
import IdeaCard from './IdeaCard';

const IdeaFeed = () => {
  const [sort, setSort] = useState<SortMode>('new');
  const { ideas, loading, votedIds, vote } = useIdeas(sort);

  const tab = (mode: SortMode, label: string) => (
    <button
      key={mode}
      onClick={() => setSort(mode)}
      className={`px-4 py-2 rounded font-bebas text-lg tracking-wide transition-colors ${
        sort === mode ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground'
      }`}
    >
      {label}
    </button>
  );

  return (
    <section id="feed" className="relative py-16 px-6" aria-label="Idea feed">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-bebas text-4xl md:text-5xl text-foreground">THE FEED</h2>
          <div className="flex items-center gap-1">
            {tab('new', 'Newest')}
            {tab('top', 'Top')}
          </div>
        </div>

        {loading ? (
          <p className="font-mono text-sm text-muted-foreground">Loading ideas...</p>
        ) : ideas.length === 0 ? (
          <p className="font-mono text-sm text-muted-foreground">
            Nothing here yet. Be the first to post something dumb.
          </p>
        ) : (
          <div className="space-y-4">
            {ideas.map(idea => (
              <IdeaCard key={idea.id} idea={idea} voted={votedIds.has(idea.id)} onVote={vote} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default IdeaFeed;
